import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";

export default function () {
    new Swiper(".swiper", {
        // Install modules
        modules: [Navigation, Pagination, Scrollbar],
        speed: 500,
        spaceBetween: 50,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination-feature",
            type: "bullets",
            clickable: true,
        },
    });
    new Swiper(".swiper-icons", {
        // Install modules
        modules: [Navigation, Scrollbar, Pagination],
        speed: 500,
        spaceBetween: 5,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-nav-next",
            prevEl: ".swiper-nav-prev",
        },
        pagination: {
            el: ".swiper-pagination-icons",
            type: "bullets",
            clickable: true,
        },

        breakpoints: {
            700: {
                slidesPerView: 2,
            },
            1100: {
                slidesPerView: 3,
            },
            1350: {
                slidesPerView: 4,
            },
        },
    });

    new Swiper(".swiper-images", {
        // Install modules
        modules: [Navigation, Scrollbar, Pagination],
        speed: 500,
        spaceBetween: 5,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-nav-next",
            prevEl: ".swiper-nav-prev",
        },
        pagination: {
            el: ".swiper-pagination-images",
            type: "bullets",
            clickable: true,
        },

        breakpoints: {
            700: {
                slidesPerView: 2,
            },
            1100: {
                slidesPerView: 3,
            },
            // 1350: {
            //     slidesPerView: 3,
            // },
        },
    });

    new Swiper(".swiper-hero", {
        // Install modules
        modules: [Navigation],
        speed: 500,
        spaceBetween: 50,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-hero-next',
            prevEl: '.swiper-hero-prev',
          },
    });
}
